export default class DatotRate {
  id?: number

  datotStudentTypeId?: number

  datotIds?: string

  rate?: number

  isLocked?: boolean

  constructor(datotRate: any) {
    this.id = datotRate.DatotStudentTypeId
    this.datotStudentTypeId = datotRate.DatotStudentTypeId
    this.datotIds = datotRate.DatotIds
    this.rate = datotRate.Rate
    this.isLocked = datotRate.IsLocked ?? false
  }
}
